// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"e0dd877b","153":"c5e6bf89","916":"31d6cfe0"}[chunkId] + ".chunk.css";
};